<template>
  <div class="container">
    <div class="ui left aligned grid">
      <h1>{{title}} Email</h1>
    </div>

    <div class="ui divider"></div>
    <form class="ui form row segment" @submit.prevent="emailUpdate">
      <div class="ui grid stackable">
        <div class="eight wide column">
          <label>From</label>
          <input
            type="email"
            name="From"
            placeholder="ray@outerbox.com, ray@jcsteele.com"
            v-model="from"
          />
        </div>
        <div class="eight wide column">
          <label>CC</label>
          <input
            type="email"
            name="CC"
            placeholder="ray@outerbox.com, ray@jcsteele.com"
            v-model="cc"
          />
        </div>
        <div class="sixteen wide column">
          <label>BCC</label>
          <input
            type="email"
            name="BCC"
            placeholder="ray@outerbox.com, ray@jcsteele.com"
            v-model="bcc"
          />
        </div>
        <div class="sixteen wide column">
          <label>Subject</label>
          <input
            type="text"
            name="Subject"
            placeholder="Subject"
            v-model="subject"
          />
        </div>
        <div class="sixteen wide column">
          <label>Email Content</label>
          <froala :config="config" v-model="content" :tag="'textarea'"></froala>
        </div>
        <div class="eight wide column">
          <div class="ui buttons">
            <button class="ui positive button">{{button}} Email</button>
            <div class="or"></div>
            <div class="ui light button" @click="$router.go(-1)">Cancel</div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import APIService from "@/assets/js/APIService";
const apiService = new APIService();
import { config } from "@/assets/js/variables.js";

export default {
  name: "EditEmail",
  computed: {},
  components: {},
  mounted() {
    if (this.$route.params.id != undefined) {
      this.emailDetails();
      this.button = 'Save';
      this.title = 'Edit';
    } else {
      this.button = 'Add';
      this.title = 'Add';
    }
  },
  data() {
    return {
      showModal: false,
      from: "",
      cc: [],
      bcc: [],
      subject: "",
      content: "",
      error: false,
      config: config,
      button: "",
      title: ""
    };
  },
  methods: {
    emailDetails() {
      apiService
        .getEmailDetails({ id: this.$route.params.id })
        .then((request) => {
          this.emailSuccessful(request);
        })
        .catch((err) => this.emailFailed(err));
    },
    emailSuccessful(request) {
      (this.from = request.from),
        (this.cc = request.cc),
        (this.bcc = request.bcc),
        (this.subject = request.subject),
        (this.content = request.content);
    },
    emailFailed(err) {
      this.$bvToast.toast("TraceID: " + err.error.response.data.traceId, {
        title: err.error.response.data.title,
        autoHideDelay: 10000,
        appendToast: false,
        variant: "danger",
        solid: true,
      });
    },
    emailUpdate() {
      if (this.$route.params.id == undefined) {
        apiService
          .createEmail({
            from: this.from,
            cc: this.cc,
            bcc: this.bcc,
            subject: this.subject,
            content: this.content,
          })
          .then((request) => {
            this.emailSuccessful(request);
            this.$router.push("/admin/emailmanagement/index");
          })
          .catch((err) => this.emailFailed(err));
      } else {
        apiService
          .updateEmail({
            id: this.$route.params.id,
            from: this.from,
            cc: this.cc,
            bcc: this.bcc,
            subject: this.subject,
            content: this.content,
          })
          .then((request) => {
            this.emailSuccessful(request);
            this.$router.push("/admin/emailmanagement/index");
          })
          .catch((err) => this.emailFailed(err));
      }
    },
  },
};
</script>

<style module></style>
